var browserDetectionValidation = function () {
    var deferred = jQuery.Deferred();

    //Checks if the browser is the Android Browser
    if (!is_native_android || TINK.getCookie('showBrowserDetection')) {
        deferred.resolve();
        return deferred;
    }

    // Set fancybox on the modal popup
    $('#modal-langswitch').attr('href', $('.js-change-my-language').attr('href'));
    $('#modal-langswitch').html($('.js-change-my-language').attr('title'));
    if ($('#browserdetection--fancybox').length != 0) {
        $.fancybox({
            'href': '#browserdetection--fancybox',
            'modal': true,
            'padding': 0,
            afterShow: function __showBrowserDetection() {
                $(this.inner)
                    .find('.focusable')
                    .first()
                    .attr('tabindex', 0)
                    .focus();
            }
        });
    }

    // If the 'hide cookie is not set we show the message
    if (!TINK.getCookie('showBrowserDetection')) {
        $('#browserdetection--fancybox').show();
    }

    $('#closebrowserdetection').click(function () {
        TINK.setCookie('showBrowserDetection', true);
        deferred.resolve();
    });

    return deferred;
};
